<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-12">
        <div class="content">
          <h3>{{ i18n.points[iso] }}</h3>
        </div>
      </div>

      <div class="column is-12">
        <div
          class="is-flex is-align-items-center is-justify-content-center"
          style="gap: 10px"
        >
          <div
            class="has-text-centered has-background-success has-text-white"
            style="
              border-radius: 12px;
              padding: 20px 40px;
              min-width: 220px;
            "
          >
            <p class="is-size-7 has-text-weight-bold">
              {{ i18n.points[iso] }}
            </p>
            <p class="is-size-3 has-text-weight-bold">{{ puntos }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="columns is-multiline" style="margin-top: 20px">
      <div class="column is-12">
        <div class="content">
          <h3>{{ i18n.pointsHistory[iso] }}</h3>
        </div>
      </div>

      <div class="column is-12">
        <b-table
          :data="historial"
          :striped="true"
          :narrowed="true"
          :hoverable="true"
          :focusable="false"
          :paginated="historial.length > 10"
          :per-page="10"
          pagination-simple
          :empty-label="i18n.noPointsHistory[iso]"
        >
          <b-table-column
            field="Monto"
            :label="i18n.amountPoint[iso]"
            centered
            v-slot="props"
          >
            <b-tag :type="props.row.Monto >= 0 ? 'is-success' : 'is-danger'">
              {{ props.row.Monto }}
            </b-tag>
          </b-table-column>

          <b-table-column
            field="Origen"
            :label="i18n.origin[iso]"
            centered
            v-slot="props"
          >
            {{ props.row.Origen || "" }}
          </b-table-column>

          <b-table-column
            field="Motivo"
            :label="i18n.addPointsReason[iso]"
            centered
            v-slot="props"
          >
            {{ props.row.Motivo || "" }}
          </b-table-column>

          <b-table-column
            field="CreadoPor"
            :label="i18n.assignedBy[iso]"
            centered
            v-slot="props"
          >
            {{ asignadoPor(props.row) }}
          </b-table-column>

          <b-table-column
            field="FechaCreacion"
            :label="i18n.creationDate[iso]"
            centered
            v-slot="props"
          >
            {{
              props.row.FechaCreacion
                ? parseDate(props.row.FechaCreacion)
                : ""
            }}
          </b-table-column>

          <b-table-column
            field="FechaExpiracion"
            :label="i18n.expirationDate[iso]"
            centered
            v-slot="props"
          >
            {{
              props.row.FechaExpiracion
                ? parseDate(props.row.FechaExpiracion)
                : ""
            }}
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "../../utils/i18n";

export default {
  props: {
    puntos: {
      type: Number,
      default: 0,
    },
    historial: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      i18n,
      iso: null,
    };
  },
  created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
    });
  },
  methods: {
    // Compras, canjes y regalos automáticos no tienen usuario ('' o 'na'): los puso el sistema.
    // Un manual sin usuario es un registro viejo del que no se sabe quién lo asignó.
    asignadoPor(row) {
      const usuario = row.CreadoPor;
      if (usuario && usuario !== "na") return usuario;
      if (row.Origen === "manual") return "—";
      return this.i18n.assignedBySystem[this.iso];
    },
    parseDate(value, withUtc = true) {
      if (!value) return "";
      let val = typeof value === "number" ? value : Date.parse(value);
      if (isNaN(val)) return "";
      const date = new Date(val);
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      if (withUtc) {
        return date.toLocaleDateString("es-MX", options);
      }
      return date.toLocaleDateString("es-MX", options);
    },
  },
};
</script>